import React, { useEffect } from "react";
import { FaRegCopy } from "react-icons/fa";
import { RxCircle, RxCheckCircled } from "react-icons/rx";

function TagSuccessCopy({ show = false, text = "Undefined" }) {
  const tagSuccessCopyStyles = {
    container: {
      display: "flex",
      position: "absolute",
      width: "100%",
      height: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(255, 255, 255)",
      zIndex: 1,
    },
    text: {
      color: "#333",
      fontWeight: "bold",
      fontSize: 14,
      marginLeft: 10,
      marginBottom: 0,
    },
  };
  return (
    show && (
      <div style={tagSuccessCopyStyles.container}>
        <RxCheckCircled color="green" />
        <p style={tagSuccessCopyStyles.text}>{text} copiado!</p>
      </div>
    )
  );
}

export default function TextAreaCopy({ title, id, value }) {
  const [showCopy, setShowCopy] = React.useState(false);

  const copy = async () => {
    const copyText = document.getElementById(`copyText-${id}`);

    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    
    try {
      document.execCommand("copy");
      navigator.clipboard.writeText(copyText.defaultValue);
      document.getSelection().removeAllRanges()
    } catch (err) {}

    setShowCopy(true);
  };

  useEffect(() => {
    let timer;

    if (showCopy) {
      timer = setTimeout(() => {
        setShowCopy(false);
      }, 500);
    }
    return () => clearTimeout(timer);
  }, [showCopy]);

  return (
    <>
      <div
        style={{
          flexDirection: "column",
          justifyContent: "space-between",
          marginHorizontal: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p>{title}</p>
          <button onClick={copy} disabled={showCopy} style={{ border: "none" }}>
            <FaRegCopy color="#666" style={{ margin: 10 }} />
          </button>
        </div>
        <div style={{ marginTop: 10, position: "relative" }}>
          <TagSuccessCopy show={showCopy} text={title} />

          <div
            style={{
              borderWidth: 1,
              borderColor: "#ccc",
              borderRadius: 5,
              width: "100%",
            }}
          >
            <textarea
              id={`copyText-${id}`}
              readOnly
              style={{
                width: "100%",
                padding: "15px",
                background: "#FFFFFF",
                height: "140px",
              }}
              onClick={copy}
              defaultValue={value}
              minLength={6}
            ></textarea>
          </div>
        </div>
      </div>
    </>
  );
}
